module.exports = "/images/events.svg?e71843c0a59b3fd6d529042d05c9b31e";